/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_ArInputs */

const en_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const es_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const de_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const zh_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const ar_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const fr_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const vi_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const sw_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const th_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const bs_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const ja_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const ko_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const pt_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const it_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const sv_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const nl_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const da_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const nb_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const fi_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const pl_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const ru_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const tr_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const hi_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const id_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const ms_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const cs_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const el_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const he_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const af_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

const hu_nav_language_ar = /** @type {(inputs: Nav_Language_ArInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العربية`)
};

/**
* | output |
* | --- |
* | "العربية" |
*
* @param {Nav_Language_ArInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_ar = /** @type {((inputs?: Nav_Language_ArInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_ArInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_ar(inputs)
	if (locale === "de") return de_nav_language_ar(inputs)
	if (locale === "zh") return zh_nav_language_ar(inputs)
	if (locale === "ar") return ar_nav_language_ar(inputs)
	if (locale === "fr") return fr_nav_language_ar(inputs)
	if (locale === "vi") return vi_nav_language_ar(inputs)
	if (locale === "sw") return sw_nav_language_ar(inputs)
	if (locale === "th") return th_nav_language_ar(inputs)
	if (locale === "bs") return bs_nav_language_ar(inputs)
	if (locale === "ja") return ja_nav_language_ar(inputs)
	if (locale === "ko") return ko_nav_language_ar(inputs)
	if (locale === "pt") return pt_nav_language_ar(inputs)
	if (locale === "it") return it_nav_language_ar(inputs)
	if (locale === "sv") return sv_nav_language_ar(inputs)
	if (locale === "nl") return nl_nav_language_ar(inputs)
	if (locale === "da") return da_nav_language_ar(inputs)
	if (locale === "nb") return nb_nav_language_ar(inputs)
	if (locale === "fi") return fi_nav_language_ar(inputs)
	if (locale === "pl") return pl_nav_language_ar(inputs)
	if (locale === "ru") return ru_nav_language_ar(inputs)
	if (locale === "tr") return tr_nav_language_ar(inputs)
	if (locale === "hi") return hi_nav_language_ar(inputs)
	if (locale === "id") return id_nav_language_ar(inputs)
	if (locale === "ms") return ms_nav_language_ar(inputs)
	if (locale === "cs") return cs_nav_language_ar(inputs)
	if (locale === "el") return el_nav_language_ar(inputs)
	if (locale === "he") return he_nav_language_ar(inputs)
	if (locale === "af") return af_nav_language_ar(inputs)
	if (locale === "hu") return hu_nav_language_ar(inputs)
	return en_nav_language_ar(inputs)
});